import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { CircularProgress } from "@mui/material";

import "./academy.css";

export default function Academy() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  return (
    <div className="academy-root">
      {isLoading && (
        <div className="academy-loader-wrapper">
          <CircularProgress color="primary" disableShrink />
        </div>
      )}
      <div className="academy-disclaimer-wrapper">
        {t("academy-page.disclaimer")}
      </div>
      <iframe
        src="https://kgyeohmlb.wixsite.com/iccc"
        className="academy-iframe"
        allowFullScreen
        onLoad={() => setIsLoading(false)}
      ></iframe>
    </div>
  );
}
